import { useMediaQuery, useTheme } from '@chakra-ui/react';

export const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)[0];
};
